import { defineComponent as _defineComponent } from 'vue'
import { GuestChargingService } from "@/services/guest-charging-service"
import ConfirmModal from "@/components/ui/ConfirmModal"
import FeedbackModal from "@/components/ui/FeedbackModal"
import ConnectorsComponent from "@/components/ui/ConnectorsComponent"
import PageHeader from "../ui/PageHeader.vue"
import LoadingComponent from "../ui/LoadingComponent.vue"
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import type { Connector } from "@/models/common"

interface ConnectorLayoutProps {
  startCallIsLoading: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectorLayout',
  props: {
    startCallIsLoading: { type: Boolean, default: false }
  },
  emits: ["connectorchanged"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit

const { t } = useI18n()

const chargerId = ref("")
const connectors = ref([])
const selectedConnector = ref<Connector>({})
const confirmMainTitle = ref("")
const address = ref("")
const isConfirmModalActive = ref(false)
const isFeedbackModalActive = ref(false)
const submitIsLoading = ref(false)

const confirmCharge = () => {
  emit("connectorchanged", {
    connector: selectedConnector.value,
    address: address.value
  })
  isConfirmModalActive.value = false
}

const connectorSelected = (connector: Connector) => {
  selectedConnector.value = connector
  confirmMainTitle.value = t("chargingPage.confirm.startCharging.mainTitle", {
    label: selectedConnector.value.label
  })
  isConfirmModalActive.value = true
}

const feedbackPopUp = () => {
  isFeedbackModalActive.value = true
}

const search = async () => {
  submitIsLoading.value = true
  connectors.value = []
  address.value = ""

  try {
    const resp = await GuestChargingService.getChargingStations(chargerId.value)
    if (resp?.data) {
      address.value = resp.data.address
      connectors.value = resp.data.connectors
    }
  } catch {
    feedbackPopUp()
  } finally {
    submitIsLoading.value = false
  }
}

const handleFeedbackModalOkClick = () => {
  isFeedbackModalActive.value = false
}

const handleConfirmModalCancel = () => {
  isConfirmModalActive.value = false
}

const __returned__ = { emit, t, chargerId, connectors, selectedConnector, confirmMainTitle, address, isConfirmModalActive, isFeedbackModalActive, submitIsLoading, confirmCharge, connectorSelected, feedbackPopUp, search, handleFeedbackModalOkClick, handleConfirmModalCancel, get GuestChargingService() { return GuestChargingService }, get ConfirmModal() { return ConfirmModal }, get FeedbackModal() { return FeedbackModal }, get ConnectorsComponent() { return ConnectorsComponent }, PageHeader, LoadingComponent, ref, get useI18n() { return useI18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})